import { render, staticRenderFns } from "./ApplyPC2.vue?vue&type=template&id=ccc70a66&scoped=true"
import script from "./ApplyPC2.vue?vue&type=script&lang=js"
export * from "./ApplyPC2.vue?vue&type=script&lang=js"
import style0 from "./ApplyPC2.vue?vue&type=style&index=0&id=ccc70a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc70a66",
  null
  
)

export default component.exports